import scConfig from "../../../sitecore.config";
import { SUPPORTED_LANGUAGES } from "../../i18n/routing";
import type { PageToRevalidate } from "../../types/Api/PageToRevalidate";

export const SHARED_LAYOUT_STALENESS_SECONDS = 3600;

export function routeTag(site: string, locale: string, path: string): string {
  return `sc:route:${site}:${locale}:${path}`;
}

export function itemTag(id: string, locale: string): string {
  return `sc:item:${id}:${locale}:latest`;
}

export function dictTag(site: string, locale: string): string {
  return `sc:dict:${site}:${locale}`;
}

export function chEntityTag(id: string): string {
  return `ch:entity:${id}`;
}

export function chSlugTag(slug: string, locale: string): string {
  return `ch:slug:${slug}:${locale}`;
}

export function sectionTag(
  site: string,
  locale: string,
  section: string,
): string {
  return `sc:section:${site}:${locale}:${section}`;
}

export function normalizeSite(site: string | null | undefined): string {
  return site || scConfig.defaultSite || "Dotcom";
}

export function normalizePath(path: string): string {
  return path.replace(/^\/+/, "").toLowerCase().replace(/\/+$/, "");
}

export function normalizeItemId(id: string): string {
  return id.replace(/-/g, "").toUpperCase();
}

export function normalizeRequestLocale(locale: string): string {
  const normalized = locale.toLowerCase();
  return SUPPORTED_LANGUAGES.includes(normalized)
    ? normalized
    : scConfig.defaultLanguage.toLowerCase();
}

export function normalizeLocale(
  lang: string,
  src: PageToRevalidate["src"],
): string {
  let locale = lang.toLowerCase();
  if (src === "ch" && locale === "en") {
    locale = "en-us";
  }
  return SUPPORTED_LANGUAGES.includes(locale)
    ? locale
    : scConfig.defaultLanguage.toLowerCase();
}
